import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// types
import { Project, Site } from '../../utils/types';

//	--------------------------------------------------------------------------
//
//	R E D U X   S T A T E   M A N A G E M E N T
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	T Y P E S
//
//	--------------------------------------------------------------------------

export interface PanelsState {
  //
  // note: the focused divs are only used if the selected item is currently
  // hidden by the filter box. the focused divs don't do anything if the selected
  // item is currently visible.
  focusedProjectDiv: { divID: number };
  focusedSiteDiv: { divID: number };
  selectedProjectDiv: { divID: number };
  selectedSiteDiv: { divID: number };
  //
}

//	--------------------------------------------------------------------------
//
//	C O N S T A N T S
//
//	--------------------------------------------------------------------------

const initialState: PanelsState = {
  focusedProjectDiv: { divID: 0 },
  focusedSiteDiv: { divID: 0 },
  selectedProjectDiv: { divID: -1 },
  selectedSiteDiv: { divID: -1 },
};

//	--------------------------------------------------------------------------
//
//	S L I C E S
//
//	--------------------------------------------------------------------------

export const panelsSlice = createSlice({
  name: 'panels',
  initialState: initialState,
  reducers: {
    //
    setFocusedProjectDiv: (
      state: PanelsState,
      action: PayloadAction<{ divID: number }>,
    ) => {
      state.focusedProjectDiv = action.payload;
    },

    setFocusedSiteDiv: (state: PanelsState, action: PayloadAction<{ divID: number }>) => {
      state.focusedSiteDiv = action.payload;
    },

    setSelectedProjectDiv: (
      state: PanelsState,
      action: PayloadAction<{ divID: number }>,
    ) => {
      state.selectedProjectDiv = action.payload;
    },

    setSelectedSiteDiv: (
      state: PanelsState,
      action: PayloadAction<{ divID: number }>,
    ) => {
      state.selectedSiteDiv = action.payload;
    },
    //
  },
});

// expose the interface.
export const {
  setFocusedProjectDiv,
  setFocusedSiteDiv,
  setSelectedProjectDiv,
  setSelectedSiteDiv,
} = panelsSlice.actions;

export default panelsSlice.reducer;
